export const loginmerchant = (session) => {
    return {
        type: "LOGIN_MERCHANT",
        payload: session,
    };
};
export const logoutMerchant = () => {
    return {
        type: "LOGOUT_MERCHANT",
    };
};
